import React, { useState, useEffect } from "react";
import {
  fetchTournamentsDataApi,
  fetchMatchDataApi,
  fetchEventTopBestBetDataApi,
} from "../api/api";
import "../styles/comman.css";
import Instant from "../component/BestBet/instant";
import BuildbetAllData from "../component/BestBet/buildbetalldata";
import { totalOddsCal, formatDateTime } from "../helper/index";
import Select from 'react-select';
import BestbetLeagueDropdown from "./BestbetLeagueDropdown"
// import BestbetMatchDropdown from "./BestbetMatchDropdown"
import { useNavigate } from "react-router-dom";

const league = process.env.REACT_APP_DEFAULT_LEAGUE;

function BestBet({ oddsFormat, language, subscriptionStatus, showPopupSignup }) {
  const [leagueData, setLeagueData] = useState([]);
  const [leagueId, setLeagueId] = useState(() => {
    return localStorage.getItem("leagueId") || league;
  });
  const [matchData, setMatchData] = useState([]);
  const [matchId, setMatchId] = useState();
  const [isLoadingSearchData, setIsLoadingSearchData] = useState(true);
  const [topBestBet, setTopBestBet] = useState([]);
  const [stake, setStake] = useState(4);
  const [totalodds, setTotalodds] = useState("");
  const [isInstantBetActive, setIsInstantBetActive] = useState(true);
  const [isBuildBet, setIsBuildBet] = useState(false);
  const [isleg, setIsleg] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const navigate = useNavigate();


  useEffect(() => {
    const fetchLeagueData = async () => {
      try {
        const leagueResponse = await fetchTournamentsDataApi(1,language,5);
        setLeagueData(leagueResponse.data || []);
      } catch (error) {
        console.error("Error fetching league data:", error);
      }
    };

    fetchLeagueData();
  }, [language]);
  

  useEffect(() => {
    if (leagueId) {
      const fetchMatchData = async () => {
        try {
          const matchResponse = await fetchMatchDataApi(1, language, 5, leagueId);
          const matches = matchResponse.data || [];
          setMatchData(matches);
          setMatchId(matches.length > 0 ? matches[0].matchid : 0);
        } catch (error) {
          console.error("Error fetching match data:", error);
        }
      };

      fetchMatchData();
    } else {
      setMatchData([]);
      setMatchId(0);
    }
  }, [language, leagueId]);

  useEffect(() => {
    if (matchId && isInstantBetActive) {
      const fetchEventTopBestBetData = async () => {
        try {
          setIsLoadingSearchData(true);
          setTopBestBet([]);

          const apidata = await fetchEventTopBestBetDataApi(
            1,
            language,
            5,
            matchId,
            stake,
            true
          );
          if (apidata && apidata.data) {
            const data = apidata.data;
            const totalOdds = totalOddsCal(oddsFormat, data.bestbet);
            if (totalOdds) {
              setTotalodds(totalOdds);
              setTopBestBet([data]);
              if (
                data.bookingOddsCount > 0 &&
                data.cornerOddsCount > 0 &&
                data.playerOddsCount > 0
              ) {
                setIsleg(true);
              } else {
                setIsleg(false);
              }
            }
          } else {
            setIsLoadingSearchData(false);
            setTopBestBet([]);
          }
        } catch (error) {
          setIsLoadingSearchData(false);
          setTopBestBet([]);
          console.error("Error fetching data:", error);
        }
      };

      fetchEventTopBestBetData();
    }
  }, [language, matchId, oddsFormat, isInstantBetActive, stake]);

  const handleLeagueChange = (e) => {
    const newLeagueId = e.target.value;
    setLeagueId(newLeagueId);
    setTotalodds(0);
    setTopBestBet([]);
    localStorage.setItem("leagueId", newLeagueId);
  };

  const handleMatchChange = (match) => {
    setMatchId(match);
    setIsInstantBetActive(true);
    setIsBuildBet(false);
  };

  const handleStakeChange = async (e) => {
    const newStake = e.target.value;
    setStake(newStake);
  };

  const handleInstantBetClick = () => {
    setIsInstantBetActive(true);
    setIsBuildBet(false);
    setStake(4);
  };

  const handleBuildBetClick = () => {
    setIsBuildBet(true);
    setTopBestBet([]);
    setIsInstantBetActive(false);
  };

  const matchOptions = matchData.map((item) => ({
    value: item.matchid,
    label: item.matchname,
    matchname: item.matchname,
    matchutcdatetime: item.matchutcdatetime,
  }));

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const customStyles = {
    control: (provided) => ({ 
      ...provided,
      width: isMobile ? '100%' : '300px',
      color: '#2b3245',
      fontFamily: 'Montserrat, sans-serif',
      fontSize: '12px',
      fontWeight:'300',
      textAlign:'left',
      cursor: 'pointer'
    }),
    menu: (provided) => ({
      ...provided,
      width: isMobile ? '100%' : '300px',
      textAlign:'left',
      zIndex: 9999 
    }),
    option: (provided, state) => ({
      ...provided,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontFamily: 'Montserrat, sans-serif',
      fontSize: '12px',
      fontWeight:'500',
      textAlign:'left',
      cursor: 'pointer',
      color: state.isSelected
        ? 'white'
        : state.isFocused
        ? '#2b3245'
        : '#2b3245',
      backgroundColor: state.isSelected
        ? '#1E73E6'
        : state.isFocused
        ? '#d3d3d3'
        : 'white',
    }),
  };

  const handleClick = () => {
    navigate("/pricing");
  };

  return (
    <div className="AF-widget AF-bestBets">
      <div className="AF-widget__header">
        <div className="grid-noGutter-middle">
          {/* <div className="col-6_lg-6_md-6_sm-6_xs-12">
            <span className="AF-widget__title">BEST BETS BUILDER</span>{" "}
            <img src="assets/images/fire-icon.svg" alt="fire" />
          </div> */}
          <div className="col-4_lg-4_md-4_sm-4_xs-12">
              <span className="AF-widget__title">BEST BETS BUILDER</span>{" "}
              <span className="tooltip-wrapper-bestbuilder-title">
                <img src="assets/images/fire-icon.svg" alt="fire-icon" className="fire-icon" />
                <span className="tooltip-text-bestbuilder-title">
                  Create custom Bet Builders using our strongest stat-based picks.
                  <ul>
                    <li>Instant Bet auto-selects a full Bet Builder based on our top data. </li>
                    <li>Build Your Bet lets you add legs manually from our top-rated options.  </li>
                  </ul>
                </span>
              </span>
            </div>
          <div className="col-8_lg-8_md-8_sm-8_xs-12 AF-filter__list">
            {/* <span className="AF-filterBy__txt">Filter by:</span> */}
            <ul>
              <li>
                {/* <div className="AF-select"> */}
                  {/* <select
                    className="truncate"
                    onChange={handleLeagueChange}
                    value={leagueId}
                  >
                    {filteredLeagues.length > 0 ? (
                      filteredLeagues.map((item, index) => (
                        <option key={index} value={item.leagueid}>
                          {item.leaguename}
                        </option>
                      ))
                    ) : (
                      <option value="" disabled>
                        League not available
                      </option>
                    )}
                  </select> */}
                  <BestbetLeagueDropdown  
                    leagueData={leagueData}
                    leagueId={leagueId}
                    handleLeagueChange={handleLeagueChange}
                    subscriptionStatus={subscriptionStatus}
                    showPopupSignup={showPopupSignup}
                  />
                {/* </div> */}
              </li>
              <li>
                <div className="">
                  <Select
                    styles={customStyles}
                    options={matchOptions}
                    value={matchOptions.find(option => option.value === matchId)}
                    onChange={(selected) => handleMatchChange(selected.value)}
                    formatOptionLabel={(e) => (
                      <div>
                        <div>{e.matchname}</div>
                        <div>{formatDateTime(e.matchutcdatetime)}</div>
                      </div>
                    )}
                    isSearchable={true}
                    placeholder="Select Match..."
                    menuIsOpen={showPopupSignup ? false : undefined}
                  />
                </div>
                {/* <BestbetMatchDropdown 
                  matchData={matchData}
                  matchId={matchId}
                  handleMatchChange={handleMatchChange}
                
                /> */}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="AF-widget__content">
        <div className="AF-matchBoxGroup clearfix">
          <div className="AF-matchBoxGroup__item">
            <button
              className={`btn ${
                isInstantBetActive ? "btn-custom-active" : "btn-custom-inactive"
              }`}
              onClick={handleInstantBetClick}
              id="btn_instance_bet"
            >
              Instant Bet
            </button>
          </div>
          <div className="AF-matchBoxGroup__item" style={{ position: "relative" }}>
            {subscriptionStatus === "Active" ? (
              <button
                className={`btn ${
                  isBuildBet ? "btn-custom-active" : "btn-custom-inactive"
                }`
              }
              onClick={handleBuildBetClick}
              id="btn_build_your_bet"
            >
              Build Your Bet
            </button>
            ) : (
              <div className="locked-advanced-filters" title="Available in Pro. Build your bet with full stats suggestions (£4.99/month).">
              <button
                className={`btn ${isBuildBet ? "btn-custom-active" : "btn-custom-inactive"}`}
                onClick={handleClick}
              >
                Build Your Bet
              </button>
              <div className="lock-overlay" >
                <span className="lock-icon">🔒</span>
              </div>
            </div>
            )}
          </div>
          <div className="AF-matchBoxGroup__item">
            
          </div>
        </div>
      </div>

      {isInstantBetActive && (
        <Instant
          topBestBet={topBestBet}
          totalodds={totalodds}
          stake={stake}
          isLoadingSearchData={isLoadingSearchData}
          handleStakeChange={handleStakeChange}
          setTotalodds={setTotalodds}
          oddsFormat={oddsFormat}
          isleg={isleg}
          language={language}
        />
      )}

      {isBuildBet && (
        <BuildbetAllData
          matchId={matchId}
          oddsFormat={oddsFormat}
          language={language}
        />
      )}
    </div>
  );
}

export default BestBet;
